import PropTypes from 'prop-types';
import React from 'react';
import { Grid } from '@custom-components';
import { connectionShape } from '../helperFunctions';
import ConnectionTable from './ConnectionTable';

import List from '../List';

class ConnectionList extends React.Component {
  static propTypes = {
    connections: PropTypes.arrayOf(connectionShape).isRequired,
    loading: PropTypes.bool,
    error: PropTypes.shape({})
  };

  static defaultProps = {
    loading: true,
    error: null
  };

  render() {
    const { connections, loading, error } = this.props;
    return (
      <Grid.ScreenClassRender
        render={(screenClass) => (
          <List
            data={connections}
            loading={loading}
            error={error}
            header={false}
            pagination={connections.length > 9}
            viewFilters={[{ id: '' }]}
            screenClass={screenClass}
            tableComponent={ConnectionTable}
            cardComponent={() => {}}
            noDataObj={{
              message: 'No Connections Set on Property',
              title: 'No Connections'
            }}
            listComponentProps={{ defaultView: 'tableView', initialSortFilterId: 'CONNECTION_UPDATE_SORT_DESC' }}
          />
        )}
      />
    );
  }
}

export default ConnectionList;
